<template>
  <div class="large-file-upload" :style="{ width, height }">
    <input
      type="file"
      class="large-file-upload__input"
      ref="lFileUploadInput"
      capture="camera"
      @change="uploadFile"
      :accept="accept"
    />
    <div class="large-file-upload__content" @click="onuploadClick">
      <slot></slot>
    </div>
    <slot name="speed" v-bind:precent="precent"></slot>
  </div>
</template>
<script>
import SparkMD5 from "spark-md5";
import api from "api";
export default {
  name: "largeFileUplod",
  props: {
    width: {
      type: String,
      default: "100px",
    },
    height: {
      type: String,
      default: "100px",
    },
    accept: {
      type: String,
    },
    getSize: {
      //获取文件大小
      type: Boolean,
      default: false,
    },
    module: {
      //业务模块代码,0-临时文件 1-营销文档.2-视频拓客.3-全域营销
      type: Number,
      default: 0,
    },
    beforeUpload: Function,
  },
  computed: {},
  data() {
    return {
      videoSrc: "",
      fileName: "",
      remainChunks: [], // 上传切片
      precent: 0, // 上传百分比
      uploadedChunkSize: 0, // 已完成上传的切片数
      chunkSize: 8 * 1024 * 1024, // 切片大小
      upload_token: "", //上传令牌
    };
  },
  created() {},
  mounted() {},
  beforeDestroy() {
    this.abort();
  },
  methods: {
    /**
     * 中断上传请求的方法
     */
    abort() {
      if (typeof this.$axiosAbortAll == "function") {
        this.$axiosAbortAll("中断文件上传");
      }
    },
    onuploadClick() {
      this.$refs.lFileUploadInput.click();
    },
    // input改变事件监听
    async uploadFile(e) {
      const file = e.target.files[0];
      let isTrue = this.beforeUpload(e.target.files);
      this.fileName = file.name;
      if (isTrue) {
        this.$emit("startUpload");
        this.precent = 1;
        this.uploadedChunkSize = 0;
        const chunkInfo = await this.cutBlob(file);
        this.remainChunks = chunkInfo.chunkArr;
        this.uploadInit().then((res) => {
          if (res.status == 0) {
            this.upload_token = res.data.upload_token;
            this.mergeRequest();
          }
        });
      }
      this.$refs.lFileUploadInput.value = null;
    },
    //  文件分割
    cutBlob(file) {
      const chunkArr = []; //所有切片缓存数组
      const blobSlice =
        File.prototype.slice ||
        File.prototype.mozSlice ||
        File.prototype.webkitSlice; //切割API不同流量器分割处理
      const spark = new SparkMD5.ArrayBuffer(); //文件hash处理
      const chunkNums = Math.ceil(file.size / this.chunkSize); //切片总数
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.addEventListener("loadend", () => {
          const content = reader.result;
          // 生成文件hash
          spark.append(content);
          const hash = spark.end();
          let startIndex = "";
          let endIndex = "";
          let contentItem = "";
          // 文件切割
          for (let i = 0; i < chunkNums; i++) {
            startIndex = i * this.chunkSize;
            endIndex = startIndex + this.chunkSize;
            endIndex > file.size && (endIndex = file.size);
            contentItem = blobSlice.call(file, startIndex, endIndex);
            chunkArr.push({
              index: i,
              hash,
              total: chunkNums,
              name: file.name,
              size: file.size,
              chunk: contentItem,
            });
          }
          resolve({
            chunkArr,
          });
        });
        reader.addEventListener("error", function _error(err) {
          reject(err);
        });
      });
    },
    // 分片上传请求（sendRequest）和合并请求（chunkMerge）
    mergeRequest() {
      const chunks = this.remainChunks;
      this.sendRequest(chunks, 1, () => {
        this.chunkMerge();
      });
    },
    sendRequest(arr, max = 1, callback) {
      let fetchArr = [];
      let toFetch = () => {
        if (!arr.length) {
          return Promise.resolve();
        }
        const chunkItem = arr.shift();
        const it = this.sendChunk(chunkItem);
        it.then(
          (res) => {
            fetchArr.splice(fetchArr.indexOf(it), 1);
          },
          (err) => {
            arr.unshift(chunkItem);
          }
        );
        fetchArr.push(it);
        let p = Promise.resolve();
        if (fetchArr.length >= max) {
          p = Promise.all(fetchArr);
        }
        return p.then(() => toFetch());
      };
      toFetch().then(
        (res) => {
          Promise.all(fetchArr).then(() => {
            callback();
          });
        },
        (err) => {
          if (err && err.message === "中断文件上传") {
            return;
          }
          this.$message.error(`${this.fileName}视频上传失败,请重新上传!`);
          this.$emit("onFaild");
        }
      );
    },
    // 分片文件上传预处理
    uploadInit() {
      return api.request("snippetUploadInit", {
        fileName: this.fileName,
        businessId: localStorage.businessId || "",
        module: this.module,
      });
    },
    // 切片上传请求
    sendChunk(item) {
      let self = this;
      let formData = new FormData();
      formData.append("files", item.chunk);
      formData.append("upload_token", this.upload_token);
      formData.append("index", item.index);
      // formData.append("name", item.name);
      return api.request(
        "snippetUpload",
        formData,
        (res) => {
          self.uploadedChunkSize > item.size
            ? item.size
            : (self.uploadedChunkSize += self.chunkSize);
          console.log("上传尺寸:", this.uploadedChunkSize);
          self.precent =
            ((self.uploadedChunkSize / item.size).toFixed(2) * 1000) / 10 < 100
              ? ((self.uploadedChunkSize / item.size).toFixed(2) * 1000) / 10
              : 99;
        },
        (err) => {}
      );
    },
    // 切片合并请求：
    chunkMerge() {
      let parms = "";
      api.request(
        "uploadMerge",
        { upload_token: this.upload_token },
        (res) => {
          this.videoSrc = res.data.file;
          this.precent = 0;
          this.$message.success(`${this.fileName}视频上传成功！`);
          if (this.module == 2) {
            this.$emit("onSuccess", {
              src: res.data.file,
              size: res.data.size,
            });
          } else {
            this.$emit("onSuccess", this.videoSrc, this.upload_token);
          }
        },
        (error) => {
          if (error && error.message === "中断文件上传") {
            return;
          }
          this.$message.error(`${this.fileName}视频上传失败,请重新上传!`);
          this.$emit("onFaild");
        }
      );
    },
  },
};
</script>
<style scoped>
.large-file-upload {
  display: inline-block;
  position: relative;
  width: 100%;
}
.large-file-upload__input {
  display: none;
}
.large-file-upload__content {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
}
</style>